interface ProductLine {
  pdv?: boolean;
  ifood?: boolean;
  total?: unknown;
  sum?: unknown;
  quantity?: unknown;
  value?: unknown;
}

/**
 * Valor da linha no card de produtos.
 * Atac manda `sum` já líquido (valortotal - desconto, com a quantidade).
 * PDV e iFood mandam `total` da linha. `quantity * value` só cobre resposta
 * antiga, em que `value` ainda era o preço unitário.
 */
export function productLineTotal(product: ProductLine): number {
  if (product.pdv || product.ifood) {
    const total = Number(product.total);
    return Number.isFinite(total) ? total : 0;
  }

  if (product.sum != null && product.sum !== '') {
    const sum = Number(product.sum);
    if (Number.isFinite(sum)) return sum;
  }

  const calculated = Number(product.quantity) * Number(product.value);
  return Number.isFinite(calculated) ? calculated : 0;
}
